// import { colors } from 'client/styles'

export default {
  container: {
    // backgroundColor: colors.opaqueBlack,
    overflowY: 'auto'
  }
}



// WEBPACK FOOTER //
// ./src/views/About/styles.js